import {RoleDto} from "./role.dto";
import {AuthObjectAccessEnum} from "../../../enum/auth-object-access-enum.enum";
import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {ObjectTypeDto} from "../../../../../core/cc/model/dto/entity/object-type.dto";

export class RoleAuthObjectTypeDto extends DtoDetail{

    public roleDto? : RoleDto;
    public roleDtoId : number;
    public roleDtoName : string;
    public objectTypeDto? : ObjectTypeDto;
    public objectTypeDtoId : number;
    public objectTypeDtoName : string;
    public accessEnum: AuthObjectAccessEnum;
    public maximumPaging: number;

}
